import React from "react";

import { HvDropdown, HvDropdownProps } from "@hitachivantara/uikit-react-core";

const BaseDropdown = ({
  values,
  classes,
  ...other
}: HvDropdownProps): JSX.Element => {
  const bigList = values != null && values?.length > 10;

  return (
    <HvDropdown
      classes={classes}
      values={values}
      showSearch={bigList}
      {...(bigList && { virtualized: true, height: 300 })}
      {...other}
    />
  );
};

export default BaseDropdown;
